import T from 'i18n-react'
import { createSelector } from 'reselect'
import * as R from 'ramda'

import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc,
} from 'helpers/ComponentSelectorUtil'

const entitiesSelector = state => state.entities
const pinSelectorFunc = state => state.pinCounts
const valuesSelectorFunc = state => state.values
const getValuesSelector = (path, id) => {
  const selector = createSelectorWithPath(`${path}.${id}`, valuesSelectorFunc)
  return (state) => ({ validationObject: selector(state) })
}

const pinSelectorHoc = (pinSelector) => (
  createSelector(
    entitiesSelector,
    pinSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const pinSelector = withPath(pinSelectorFunc)

  const pinSourceSelector = pinSelectorHoc(pinSelector)

  return {
    valuesSelector,
    labelSelector,
    pinSourceSelector,
  }
}
export {
  getValuesSelector,
}
